import { useState, useEffect } from "react";

const SECRET_COMBO = ["Control", "Shift", "D"]; // Modify as needed

const DebugFooter = () => {
  const [showDebugInfo, setShowDebugInfo] = useState(false);
  const [keysPressed, setKeysPressed] = useState<string[]>([]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      setKeysPressed((prevKeys) => [...prevKeys, event.key].slice(-SECRET_COMBO.length));
    };

    const handleKeyUp = () => {
      if (JSON.stringify(keysPressed) === JSON.stringify(SECRET_COMBO)) {
        setShowDebugInfo((prev) => !prev);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [keysPressed]);

  return (
    <div>
      {showDebugInfo && (
        <div style={{ position: "fixed", bottom: 0, width: "100%", background: "black", color: "white", textAlign: "center", padding: "5px" }}>
          SBS FEATURE LOGIN: {process.env.REACT_APP_SBS_FEATURE_LOGIN}
        </div>
      )}
    </div>
  );
};

export default DebugFooter;